<template>
  <section class="sustainability-hero-2025">
    <div
      class="sustainability-hero-2025__image"
      :style="{
        '--backgroundImageSmall': `url(${images?.smallMedia})`,
        '--backgroundImageMedium': `url(${images?.mediumMedia})`,
        '--backgroundImageLarge': `url(${images?.largeMedia})`,
      }"
    >
      <img
        class="sustainability-hero-2025__image-mobile"
        :src="images?.smallMedia"
        alt=""
      />
    </div>

    <div class="sustainability-hero-2025__content">
      <h1 class="sustainability-hero-2025__title">SUSTAINABILITY 2025</h1>

      <nav class="sustainability-hero-2025__nav">
        <button
          v-for="link in primaryLinks"
          :key="link.slug"
          type="button"
          :class="[
            'sustainability-hero-2025__nav-link',
            {
              'sustainability-hero-2025__nav-link--active':
                (selectedSection || 'introduction') === link.slug,
            },
          ]"
          @click="navigateToSection(link.slug)"
        >
          {{ link.label }}
        </button>

        <a
          v-for="report in reportLinks"
          :key="report.href"
          :href="report.href"
          class="sustainability-hero-2025__nav-link sustainability-hero-2025__nav-link--report"
        >
          {{ report.label }}
        </a>
      </nav>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "SustainabilityHero2025",
  props: {
    images: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      primaryLinks: [
        { label: "Introduction", slug: "introduction" },
        { label: "People", slug: "people" },
        { label: "Planet", slug: "planet" },
        { label: "Product", slug: "product" },
        { label: "Appendix", slug: "appendix" },
      ],
      reportLinks: [
        {
          label: "2023 Report",
          href: "/pages/sustainability-report-2023",
        },
        {
          label: "2024 Report",
          href: "/pages/sustainability-report-2024",
        },
      ],
    };
  },
  computed: {
    ...mapState("sustainability", ["selectedSection"]),
  },
  methods: {
    ...mapActions("sustainability", ["updateSelectedSection"]),
    navigateToSection(slug) {
      this.updateSelectedSection({ section: slug, navigate: true });
    },
  },
};
</script>

<style lang="scss" scoped>
.sustainability-hero-2025 {
  background-color: $color-white;
  display: flex;
  flex-direction: column;

  @include respond-above(md) {
    padding: 0 15px;
  }
}

.sustainability-hero-2025__image {
  background: none;
  order: 2;
}

.sustainability-hero-2025__image-mobile {
  display: block;
  width: 100%;
  height: auto;

  @include respond-above(sm) {
    display: none;
  }
}

.sustainability-hero-2025__image {
  @include respond-above(sm) {
    background-image: var(--backgroundImageMedium);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    aspect-ratio: 16 / 9;
  }

  @include respond-above(md) {
    background-image: var(--backgroundImageLarge);
    aspect-ratio: 21 / 9;
  }
}

.sustainability-hero-2025__content {
  order: 1;
  padding: 24px 24px 32px;
  background-color: $color-white;

  @include respond-above(md) {
    order: 2;
    max-width: 1280px;
    padding: 24px 30px 32px;
  }
}

.sustainability-hero-2025__image {
  @include respond-above(md) {
    order: 1;
  }
}

.sustainability-hero-2025__title {
  @include editorial-headline(35px);
  text-transform: uppercase;
  margin: 0 0 16px;

  @include respond-above(md) {
    @include editorial-headline(96px);
    margin-bottom: 24px;
  }
}

.sustainability-hero-2025__nav {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  gap: 27px;
  align-items: center;
  @include utility-label(13px);
  -webkit-overflow-scrolling: touch;

  @include respond-above(md) {
    flex-wrap: wrap;
    overflow: visible;
  }
}

.sustainability-hero-2025__nav-link {
  flex: 0 0 auto;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  @include utility-label(13px);
  text-transform: none;
  color: rgba(0, 0, 0, 0.65);
}

.sustainability-hero-2025__nav-link--active {
  font-weight: 600;
}

.sustainability-hero-2025__nav-link--report {
  text-decoration: none;
}
</style>
